"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HistoricVolumeId = exports.HistoricVolumeSourceType = void 0;
var HistoricVolumeSourceType;
(function (HistoricVolumeSourceType) {
    HistoricVolumeSourceType["FILE"] = "file";
    HistoricVolumeSourceType["WORKING_UNIT"] = "workingUnit";
    HistoricVolumeSourceType["DATABASE"] = "database";
    HistoricVolumeSourceType["API"] = "api";
    HistoricVolumeSourceType["MANUAL"] = "manual";
})(HistoricVolumeSourceType || (exports.HistoricVolumeSourceType = HistoricVolumeSourceType = {}));
var HistoricVolumeId;
(function (HistoricVolumeId) {
    HistoricVolumeId[HistoricVolumeId["DO_NOT_USE"] = -1] = "DO_NOT_USE";
    HistoricVolumeId[HistoricVolumeId["DEFAULT"] = 0] = "DEFAULT";
})(HistoricVolumeId || (exports.HistoricVolumeId = HistoricVolumeId = {}));
